import { render, staticRenderFns } from "./FiltroLojaTeste.vue?vue&type=template&id=18b441b3&"
import script from "./FiltroLojaTeste.vue?vue&type=script&lang=js&"
export * from "./FiltroLojaTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports